import React, { createRef, useMemo } from 'react';
import * as S from '../style';

import { TooltipHover } from 'components/uikit/Tooltip/TooltipHover/TooltipHover';

export const DealActionButtons = ({ buttons }) => {
  const refs = useMemo(() => buttons.map(() => createRef()), [buttons]);

  return (
    <S.WrapButton>
      {buttons.map(({ title, clickHandler, id, disabled = false, theme = 7, hint }, index) => (
        <div key={id}>
          <div ref={refs[index]}>
            <S.OptionButton onClick={clickHandler} theme={theme} disabled={disabled}>
              {title}
            </S.OptionButton>
          </div>
          {disabled && hint && (
            <TooltipHover targetRef={refs[index]} theme="2" size="s" position="top">
              {hint}
            </TooltipHover>
          )}
        </div>
      ))}
    </S.WrapButton>
  );
};
